<template>
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    :class="[size, color]"
    viewBox="0 0 50 49.98"
  >
    <g opacity=".35">
      <g id="b">
        <path
          id="c"
          d="m45.09,10.12c-.74-1-1.55-1.94-2.43-2.82-9.77-9.76-25.6-9.74-35.36.03C2.63,12.02,0,18.37,0,24.99c-.01,5.35,1.71,10.57,4.9,14.86.74,1,1.55,1.94,2.43,2.82,9.77,9.76,25.6,9.75,35.36-.02,4.68-4.68,7.31-11.03,7.31-17.66.02-5.36-1.7-10.58-4.9-14.88m-20.1,36.17c-11.77,0-21.32-9.53-21.32-21.3S13.21,3.67,24.98,3.67c11.77,0,21.32,9.53,21.32,21.3,0,0,0,.02,0,.02-.02,11.76-9.55,21.28-21.3,21.3"
          stroke-width="0"
        />
      </g>
    </g>
    <g opacity=".35">
      <path
        d="m21.6,30.75v9.24c0,.55-.45,1-1,1h-3.23c-.55,0-1-.45-1-1V9.96c0-.55.45-1,1-1h8.85c3.69,0,6.51.86,8.44,2.58s2.9,4.21,2.9,7.47-1.09,5.75-3.27,7.75-5.12,2.99-8.83,2.99h-2.87c-.55,0-1,.45-1,1Zm0-16.5v10.24c0,.55.45,1,1,1h2.44c2.31,0,4.06-.53,5.25-1.6s1.79-2.62,1.79-4.66-.56-3.49-1.69-4.49-2.81-1.5-5.06-1.5h-2.73c-.55,0-1,.45-1,1Z"
        stroke-width="0"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "KindergartenIcon",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: function (value) {
        // The value must match one of these strings
        return ["small", "medium", "large"].includes(value);
      },
    },
    color: {
      type: String,
      default: "grey",
      validator: function (value) {
        // The value must match one of these strings
        return ["light-grey", "grey", "primary", "secondary"].includes(value);
      },
    },
  },
};
</script>

<style scoped>
.medium {
  width: 20px;
  height: 20px;
}

.light-grey path {
  fill: #c5c5c5;
}

.grey path {
  fill: #4a4a4a;
}

.primary path {
  fill: #619bc4;
}
.secondary path {
  fill: #d9835e;
}
</style>
